import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { apiService } from '../../services/ApiService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = apiService.isAuthenticated();

  if (!isAuthenticated) {
    // Rediriger vers la page de connexion avec l'emplacement d'origine pour le retour après connexion
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
